import {RouteObject} from 'react-router';
import {ROUTES} from '../routes';
import {SnTrackingSitesListing} from './sn-tracking-sites-listing';
import {TrackedSnListing} from './tracked-sn-listing';
import {ProtectedRoute} from '../auth/require-authorization';

export const SerialNumberTrackingRoutes: RouteObject = {
  path: ROUTES.ADMIN.SERIAL_NUMBER_TRACKING.path,
  element: (
    <ProtectedRoute
      role={['Global Admin', 'Partner Site Manager', 'Partner Site User', 'Serial Number Tracking User']}
    />
  ),
  children: [
    {
      path: ROUTES.ADMIN.SERIAL_NUMBER_TRACKING.INDEX.path,
      element: <SnTrackingSitesListing />,
    },
    {
      path: ROUTES.ADMIN.SERIAL_NUMBER_TRACKING.DETAIL.path,
      element: <TrackedSnListing />,
    },
  ],
};
